import { Badge } from "@/v2-components/ui/badge";
import { PARTNER_DATA } from "../_constants/about-constants";
import Hologate from "@/v2-components/pages/about/svgs/hologate";
import Sandbox from "@/v2-components/pages/about/svgs/sandbox";
import Vex from "@/v2-components/pages/about/svgs/vex";
import Tekzone from "@/v2-components/pages/about/svgs/tekzone";
import Unbound from "@/v2-components/pages/about/svgs/unbound";
import Knoxlabs from "@/v2-components/pages/about/svgs/knoxlabs";
import ImmersiveDisplay from "@/v2-components/pages/about/svgs/immersive-display";
import { useTrans } from "@/utils/useTrans";
import Ask from "@/v2-components/pages/about/svgs/ask";
import Taobao from "@/v2-components/pages/about/svgs/taobao";
import Invelon from "@/v2-components/pages/about/svgs/invelon";

// Component mapping for partner SVGs
const PARTNER_COMPONENTS = {
  Hologate,
  Sandbox,
  Vex,
  Tekzone,
  Unbound,
  Knoxlabs,
  ImmersiveDisplay,
  Ask,
  Taobao,
  Invelon,
};

interface PartnerGroupProps {
  title: string;
  partners: { name: string; component: string }[];
}

function PartnerGroup({ title, partners }: PartnerGroupProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-4">
      <Badge size="xs" variant="new" className="font-400">
        {title}
      </Badge>
      <div className="flex flex-col flex-wrap items-center justify-center gap-x-16 gap-y-12 self-stretch sm:flex smd:w-[740px] smd:flex-row">
        {partners.map((partner) => {
          const Component =
            PARTNER_COMPONENTS[
              partner.component as keyof typeof PARTNER_COMPONENTS
            ];
          return Component ? <Component key={partner.name} /> : null;
        })}
      </div>
    </div>
  );
}

export default function PartnersSection() {
  const { t } = useTrans(["about"]);
  return (
    <div className="flex flex-col items-center justify-center gap-5 self-stretch laptop:gap-8">
      <div className="justify-start self-stretch text-center text-2xl laptop:text-4xl">
        {t(`Our Partners`)}
      </div>
      <PartnerGroup title={t(`LBE`)} partners={PARTNER_DATA.lbe} />
      <PartnerGroup
        title={t(`Distribution`)}
        partners={PARTNER_DATA.distribution}
      />
    </div>
  );
}
